import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { cloneDeep } from 'lodash';

import { ApplicationApiService } from '../index';
import { IApplication, IApplicationInput, IProgramCycle, UpdateContractorAcceptRejectProject } from '@ebb-v2/ebb-integration';

import { Apollo} from 'apollo-angular';
import {
  ListInspectionCompleteApplicationsQuery,
  ListApplicationsQuery,
  GetApplicationByIdQuery,
  GET_PROGRAMCYCLES_QUERY,
  SaveApplicationMutation
} from '@ebb-v2/ebb-integration';
import { DocumentNode } from '@apollo/client/core';

@Injectable({
    providedIn: 'root'
  })
  export class ApplicationGqlService implements ApplicationApiService {


    constructor(
      private apollo: Apollo
    ) { }

    public getApplication(id: string): Observable<IApplication|string> {
      return this.apollo
        .query ({
          query: GetApplicationByIdQuery,
          errorPolicy: 'all',
          variables: {
            id: id,
          },
          fetchPolicy: 'network-only'
        })
        .pipe(
          map(result => {
            const returnValue = result.data['application'] as IApplication
            if(returnValue) {
              return returnValue;
            } else {
              let returnString = 'Error loading application';
              if(result.errors && result.errors.length > 0){
                returnString = result.errors[0].message;
              }
              return returnString;
            }
          })
          );
    }

    public getApplicationList(): Observable<IApplication[]> {
      return this.apollo
        .query ({
          query: ListApplicationsQuery,
          fetchPolicy: 'network-only'
        })
        .pipe(map(result => result.data['applications'] as IApplication[]));
    }

    public getApplicationListByType(type: DocumentNode): Observable<IApplication[]> {
      return this.apollo
        .query ({
          query: type,
          variables: {
            type: type,
          },
          fetchPolicy: 'network-only'
        })
        .pipe(map(result => result.data['applications'] as IApplication[]));
    }

    public getProgramCycles(): Observable<IProgramCycle[]> {
       return this.apollo
        .query ({
          query: GET_PROGRAMCYCLES_QUERY,
          fetchPolicy: 'network-only'
        })
        .pipe(map(result => result.data['programcyclescanregister'] as IProgramCycle[]));
    }

    public updateApplication(applicationInput: IApplicationInput, applicationId: string,applicationNote:string): Observable<any> {
      //console.log(`ApplicationApi.updateApplication ${JSON.stringify(applicationInput)}, ${applicationId})`);
       applicationNote = applicationNote || '';
      return this.apollo
        .mutate({
          mutation: SaveApplicationMutation,
          variables : {
            applicationInput,
            applicationId,
            applicationNote
          }
        })
        .pipe(map(result => result.data['saveApplication'].id as string));
    }
    public updateContractorAcceptRejectProject(applicationInput: IApplicationInput, applicationId: string): Observable<any> {
      //console.log(`ApplicationApi.updateContractorAcceptRejectProject ${JSON.stringify(applicationInput)}, ${applicationId})`);
      return this.apollo
        .mutate({
          mutation: UpdateContractorAcceptRejectProject,
          variables : {
            applicationInput,
            applicationId
          }
        })
        .pipe(map(result => result.data['updateContractorAcceptRejectProject'].id as string));
    }

    public removeApplication(application: IApplication): Observable<IApplication> {
        return null;
    }
  }
